<template>
    <div class="smollSearch">
        <form autocomplete="off" ref="searchForm" method="get" :action="data.link">
            <input
                name="q"
                v-model="input"
                @keyup="keyUp"
                @click="showBlock"
                @blur="hide"
               type="text">
            <button>
                {{data.messages.btn}}
            </button>
        </form>
        <div class="head_search_result" v-if="items.length>0&&show">
            <div class="search-res">
                <div class="one-search-res" v-for="item in items">
                    <a :href="item.link">
                        <div class="one-search-thumb">
                            <img v-for="pict in item.images"
                                :src="pict.src"
                                width="60"
                                :alt="pict.alt"
                                :title="pict.title"
                            />
                        </div>
                        <div class="one-search-descr">
                            <div class="one-search-tit">
                                {{item.name}}
                            </div>
                            <div class="one-search-price">
                                {{item.price}}
                            </div>
                        </div>
                    </a>
                </div>

                <div class="all-search-res" v-if="pagen.text">
                    <a class="head_search_submit" href="javascript:void(0);" v-on:click="resultPage">
                        {{pagen.text}} <span>{{pagen.count}}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "smollSearch",
    props:{data: Object},
    data() {
      return {
          input:'',
          items:[],
          pagen:{},
          show:false,
          resultLink:'',
      }
    },
    methods:{
        keyUp() {
            this.show=true;
            this.getSearchResult();
        },
        showBlock() {
            this.show=true;
        },
        hide() {
            setTimeout(()=>{
                this.show=false;
            },500);
        },
        resultPage(){
          // $('body').append(this.webtrecking);
          location.href= this.data.link + '?q=' + this.input;
        },
        async getSearchResult() {
            this.items=[];
            this.pagen= {};

            axios.post(this.data.ajaxLink, {
                handler:'search',
                func:'getSearch',
                q:this.input
            }).then((response)=>{

                if(response.data.status=="success") {
                    this.items=response.data.data.items;
                    this.pagen= response.data.data.pagen;
                }

                if (response.data.status=="error"){
                  var eventType = "SearchRequest";
                  var searchRequest = {
                    "SearchRequest": {
                      "search": this.input,
                      "isFound": 0
                    }
                  };

                  var scriptTag = document.createElement('script');
                  scriptTag.textContent = "eS('sendEvent', '" + eventType + "', " + JSON.stringify(searchRequest) + ");";

                  $('body').append(scriptTag);
                }
            });
        }
    }
}
</script>

<style scoped>
form input, form button {
    float: none;
}
.smollSearch{
    position: relative;
}
    .head_search_result {
        display: block;
        position: absolute;
        z-index: 20;
    }
    .head_search_result .search-res {
        border: 1px solid #cecece;
        border-radius: 6px;
        margin-top: 25px;
        width: 230px;
        right: 0;
        top: 15px;
        background-color: #fff;
        padding-top: 15px;
        -webkit-box-shadow: 0px 3px 10px 0px rgba(50, 50, 50, 0.5);
        -moz-box-shadow: 0px 3px 10px 0px rgba(50, 50, 50, 0.5);
        box-shadow: 0px 3px 10px 0px;
    }
    .search-res .one-search-res {
        cursor: pointer;
        float: left;
        width: 100%;
        padding: 12px;
        border-bottom: 1px solid #ebe7e9;
        -webkit-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition: all 0.3s;
    }
    .search-res .all-search-res {
        color: #7b7c7e;
        text-align: center;
        padding: 4px;
    }
    .search-res .one-search-res a {
        color: #3c3d41;
        display: flex;
    }
    .head_search_submit {
        color: #3c3d41;
    }
    .one-search-thumb {
        border: none;
        height: auto;
        width: auto;
        display: inline-block;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        padding: 0;
    }
</style>